var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-button',{class:_vm.styleClass,attrs:{"type":_vm.type,"loading":_vm.loading,"disabled":_vm.disabled},on:{"click":_vm.handleDelete}},[_vm._t("default",[_vm._v(_vm._s(_vm.actionVerb)+" "+_vm._s(_vm.label))])],2)}
var staticRenderFns = []

export { render, staticRenderFns }